import LoggerHelper from "./LoggerHelper";

export default class NotificationHelper {
    public static serviceWorker = "/pushnotification.serviceworker.js";

    public static init() {
        if (!(<any>window).App.bag || !(<any>window).App.bag.vapidPublicKey) {
            return;
        }

        if ((<any>window).Notification) {
            Notification.requestPermission().then(function (status) {
                if (status === "granted") {
                    NotificationHelper.initializeServiceWorker();
                }
            });
        }
    }

    private static initializeServiceWorker() {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.register(this.serviceWorker, { scope: "/" }).then(this.initializeState);
        } else {
            LoggerHelper.error("Service workers are not supported in this browser");
        }
    }

    private static async initializeState(swRegistration) {
        if (!swRegistration.showNotification) {
            LoggerHelper.error("Notifications are not supported");
            return;
        }

        if (!("PushManager" in window)) {
            LoggerHelper.error("Push messaging is not supported");
            return;
        }

        navigator.serviceWorker.ready.then(async function (swRegistration) {
            let subscription = await swRegistration.pushManager.getSubscription();
            if (!subscription) {
                NotificationHelper.subscribe();
            } else {
                let result = await (<any>window).App.instances.vm.$store.dispatch("pushNotificationStore/getPushSubscriptions", {
                    Endpoint: subscription.endpoint,
                    P256DH: NotificationHelper.base64Encode(subscription.getKey("p256dh")),
                    Auth: NotificationHelper.base64Encode(subscription.getKey("auth"))
                });

                if (!result.data.some(function (x) { return x.channel === (<any>window).App.bag.channel; })) {
                    NotificationHelper.subscribe();
                }
            }
        });
    }

    private static async subscribe() {
        navigator.serviceWorker.ready.then(function (swRegistration) {
            var applicationServerKey = NotificationHelper.urlB64ToUint8Array((<any>window).App.bag.vapidPublicKey);

            var subscribeParams = { userVisibleOnly: true, applicationServerKey: applicationServerKey };

            swRegistration.pushManager.subscribe(subscribeParams).then(async function (subscription) {
                var endpoint = subscription.endpoint,
                    p256dh = NotificationHelper.base64Encode(subscription.getKey("p256dh")),
                    auth = NotificationHelper.base64Encode(subscription.getKey("auth"));

                await (<any>window).App.instances.vm.$store.dispatch("pushNotificationStore/createPushSubscription", {
                    Endpoint: endpoint,
                    P256DH: p256dh,
                    Auth: auth,
                    Region: (<any>window).App.bag.region,
                    Language: (<any>window).App.bag.language,
                    Channel: (<any>window).App.bag.channel
                });
            }).catch(function (e) {
                LoggerHelper.error(e);
            });
        });
    }

    private static urlB64ToUint8Array(base64String) {
        var padding = "=".repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);

        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }

        return outputArray;
    }

    private static base64Encode(arrayBuffer) {
        return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
    }

    public static checkPermession() {
        return Notification.permission == "default";
    }
}